export default "__VITE_ASSET__CfW2kWOY__"